import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import LoadingScreen from '../components/LoadingScreen'

export default connect(mapSelectorsToProps(['loading']))(LoadingScreen)
